<template>

    <div>
        <el-card shadow="never">
            <el-row>
                <el-col :span="10" :offset="2" align="left">
                    <h1 style="text-align:left">All Case</h1>
                </el-col>
                <el-col :span="10" align="left">
                    <el-row>
                        <el-col
                            :span="12"
                            align="left"
                            style="padding-right: 10px;"
                        >
                            <el-button type="primary" style="width: 100%;" to=""
                                >GENERATE NOTIFY</el-button
                            >
                        </el-col>
                        <el-col :span="12" align="left">
                            <el-select
                                v-model="csNameFilter"
                                placeholder="CS name"
                                @change="filterCase"
                            >
                                <el-option
                                    v-for="item in allCsName"
                                    :key="item.customer_support_id"
                                    :label="item.name"
                                    :value="item.customer_support_id"
                                ></el-option>
                            </el-select>
                        </el-col>
                    </el-row>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="10" :offset="2" align="left">
                    <el-autocomplete
                        v-model="shopSearchFilter"
                        placeholder="ค้นหาชื่อร้าน, อีเมล, Shop Code"
                        style="width: 80%;"
                    ></el-autocomplete>
                </el-col>
                <el-col :span="10" align="left">
                    <el-row>
                        <el-col style="padding-right: 10px;">
                            <el-date-picker
                                v-model="caseDatePickerFilter"
                                type="date"
                                placeholder="Pick a day"
                                style="margin-right: 10px;"
                                @change="filterCase"
                            >
                                >
                            </el-date-picker>
                            <el-button>Export</el-button>
                        </el-col>
                    </el-row>
                </el-col>
            </el-row>

            <el-row>
                <el-col
                    :span="22"
                    :offset="2"
                    align="left"
                    style="margin-top: 20px;"
                >
                    <el-radio-group
                        v-model="flagCaseFilter"
                        @change="filterCase"
                    >
                        <el-radio-button label="ทั้งหมด"></el-radio-button>
                        <el-radio-button label="Flag Case"></el-radio-button>
                        <el-radio-button label="Line Case"></el-radio-button>
                    </el-radio-group>
                    <el-button style="margin-left: 10px;">เพิ่มเคส</el-button>
                </el-col>
            </el-row>

            <el-row style="margin-top: 30px; margin-bottom: -20px">
                <el-col :span="22" :offset="2" align="left">
                    <el-radio-group
                        v-model="caseDateFilter"
                        @change="filterCase"
                    >
                        <el-radio-button
                            :label="date.name"
                            v-for="date in allDate"
                            :key="date.name"
                        >
                            <el-badge :value="date[date.name]" class="item">
                            </el-badge
                            ><br />{{ date.name }}</el-radio-button
                        >
                    </el-radio-group>
                </el-col>
            </el-row>
        </el-card>

        <el-row>
            <el-col
                :span="22"
                :offset="2"
                align="left"
                style="margin-top:10px;"
            >
                <el-button
                    v-for="status in allStatus"
                    :key="status.code"
                    @click="(statusFilter = status), filterCase()"
                    size="mini"
                    :style="{
                        color: status.textColor,
                        'background-color': status.color
                    }"
                    >{{ status.code }} <br />
                    {{ status.number_of_cases }}
                </el-button>
            </el-col>
        </el-row>

        <el-table
            ref="OrderList"
            :data="tableData"
            :header-cell-style="{ 'background-color': 'black', color: 'white' }"
            style="width: 100%; margin-top: 10px;"
        >
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column label="Order & Tracking" width="150"
                ><template slot-scope="scope">
                    {{ scope.row.order_number }}</template
                ></el-table-column
            >
            <el-table-column label="Shop Name" width="150"
                ><template slot-scope="scope">
                    {{ scope.row.shop_name }}</template
                ></el-table-column
            >
            <el-table-column label="Description" width="150"
                ><template slot-scope="scope">
                    {{ scope.row.description }}</template
                ></el-table-column
            >

            <el-table-column label="Priority" width="100">
                <template slot-scope="scope">
                    <el-select
                        v-model="scope.row.priority.priority"
                        placeholder="Select"
                    >
                        <el-option
                            v-for="item in allPriority"
                            :key="item.priority_id"
                            :label="item.priority"
                            :value="item.priority"
                        >
                        </el-option>
                    </el-select>
                </template>
            </el-table-column>

            <el-table-column label="Due Date" width="150"
                ><template slot-scope="scope">
                    {{ scope.row.due_date | dayjs('format', 'YYYY-MM-DD HH:mm:ss') }}</template
                ></el-table-column
            >

            <el-table-column label="Flag" width="100">
                <template slot-scope="scope">
                    <el-select
                        v-model="scope.row.flag.flag"
                        placeholder="Select"
                    >
                        <el-option
                            v-for="item in allFlag"
                            :key="item.flag_id"
                            :label="item.flag"
                            :value="item.flag"
                        >
                        </el-option>
                    </el-select>
                </template>
            </el-table-column>

            <el-table-column label="Status" width="200">
                <template slot-scope="scope">
                    <el-select
                        v-model="scope.row.status.code"
                        placeholder="Select"
                    >
                        <el-option
                            v-for="item in allStatusTable"
                            :key="`td-${scope.row.order_number}-${item.status_id}`"
                            :label="item.code"
                            :value="item.code"
                        >
                        </el-option>
                    </el-select>
                </template>
            </el-table-column>

             <el-table-column label="เหตุผลหลัก" width="200">
                <template slot-scope="scope">
                    <el-select
                        v-model="scope.row.main_reason.description"
                        @change="scope.row.second_reason.description = null"
                        placeholder="Select"
                    >
                        <el-option
                            v-for="item in allReason"
                            :key="item.main_reason_id"
                            :label="item.description"
                            :value="item.description"
                        >
                        </el-option>
                    </el-select>
                </template>
            </el-table-column>

            <el-table-column label="เหตุผลหลักรอง" width="200">
                <template slot-scope="scope">
                    <el-select
                        v-model="scope.row.second_reason.description"
                        placeholder="Select"
                    >
                        <el-option
                            v-for="item in second_reasons(scope.row.main_reason.description)"
                            :key="item.second_reason_id"
                            :label="item.description"
                            :value="item.description"
                        >
                        </el-option>
                    </el-select>
                </template>
            </el-table-column>

            <el-table-column label="จัดการ" width="150">
                <template  slot-scope="scope">
                    <center>
                        <el-button size="mini">detail</el-button>
                        <br />
                        <el-button type="success" size="mini" @click="updateCase(scope.row)">บันทึก</el-button>
                    </center>
                </template>
            </el-table-column>

        </el-table>

        <el-col style="margin-top:10px;">
            <el-pagination
                @size-change="changeLimitPage"
                @current-change="changeCurrentPage"
                :current-page.sync="pagination.currentPage"
                :page-sizes="pagination.pageSizes"
                :page-size="10"
                layout="prev, pager, next, sizes"
                :total="pagination.allPage * pagination.limit"
            ></el-pagination>
        </el-col>
    </div>
</template>

<script>
import fgApi from '@/services/fillgoods'
import moment from 'moment'

export default {

    data () {
        return {
            pagination: {
                limit: 10,
                offset: 0,
                allPage: 1,
                currentPage: 1,
                pageSizes: [10, 20, 50, 100, 200]
            },
            allStatus: [
                {
                    code: 'ทั้งหมด',
                    status: 'ทั้งหมด',
                    textColor: '',
                    number_of_cases: 0,
                    color: 'primary'
                },
                {
                    code: 'รอดำเนินการ',
                    textColor: 'white',
                    color: 'gray'
                },
                {
                    code: 'รอร้านค้าตอบกลับ',
                    textColor: 'white',
                    color: 'red'
                },
                {
                    code: 'รอขนส่งตอบกลับ',
                    textColor: 'white',
                    color: 'darkorange'
                },
                {
                    code: 'รอผู้รับตอบกลับ',
                    textColor: 'white',
                    color: 'orange'
                },

                {
                    code: 'ติดตาม',
                    textColor: 'white',
                    color: 'orange'
                },
                {
                    code: 'นำกลับ',
                    textColor: 'white',
                    color: 'violet'
                },
                {
                    code: 'กำลังทำ',
                    textColor: 'white',
                    color: 'lightgreen'
                },
                {
                    code: 'รอส่งสำเร็จ',
                    textColor: 'white',
                    color: 'green'
                },
                {
                    code: 'สำเร็จ',
                    textColor: 'white',
                    color: 'darkgreen'
                }
            ],
            allCsName: [],
            currentDate: moment().format('YYYY-MM-DD'),
            allDate: [
                {
                    name: 'ทั้งหมด'

                },
                {
                    name: 'ส่งวันนี้'
                },
                {
                    name: 'กำหนดส่งวันนี้'
                },
                {
                    name: 'Late 1',
                    start: moment().subtract(1, 'days').format('YYYY-MM-DD'),
                    end: moment().format('YYYY-MM-DD')
                },
                {
                    name: 'Late 2',
                    start: moment().subtract(2, 'days').format('YYYY-MM-DD'),
                    end: moment().subtract(1, 'days').format('YYYY-MM-DD')

                },
                {
                    name: 'Late 3',
                    start: moment().subtract(3, 'days').format('YYYY-MM-DD'),
                    end: moment().subtract(2, 'days').format('YYYY-MM-DD')
                },
                {
                    name: 'Late 4',
                    start: moment().subtract(4, 'days').format('YYYY-MM-DD'),
                    end: moment().subtract(3, 'days').format('YYYY-MM-DD')
                },
                {
                    name: 'Late 5',
                    start: moment().subtract(5, 'days').format('YYYY-MM-DD'),
                    end: moment().subtract(4, 'days').format('YYYY-MM-DD')

                },
                {
                    name: 'Late 6',
                    start: moment().subtract(6, 'days').format('YYYY-MM-DD'),
                    end: moment().subtract(5, 'days').format('YYYY-MM-DD')
                },
                {
                    name: 'Late 7+',
                    start: moment().subtract(7, 'days').format('YYYY-MM-DD'),
                    end: moment().subtract(6, 'days').format('YYYY-MM-DD')
                }
            ],
            allFlag: [],
            allPriority: [],
            allStatusTable: [],
            allReason: [],
            shopSearchFilter: '',
            csNameFilter: '',
            caseDatePickerFilter: new Date(),
            flagCaseFilter: 'ทั้งหมด',
            caseDateFilter: 'ทั้งหมด',
            statusFilter: '',
            activeName: 'first',
            tableData: []
        }
    },
    created  () {
        this.getDataFilter()
        this.getlistCase()
        this.filterCase()
    },
    computed: {

    },
    methods: {
        async getlistCase (statusId = '', flagId = '', startDate = '', endDate = '') {
            let caseList = await fgApi.caseTracking.getListCase(statusId, flagId, startDate, endDate, this.pagination.limit, this.pagination.offset)
            console.log('caseList', caseList.data)
            this.tableData = caseList.data.result
            this.pagination.allPage = caseList.data.all_page
        },
        mapObjectData (arr1, arr2) {
            return arr1.map(item => ({
                ...item,
                ...arr2.find(e => {
                    return e.code === item.code
                })
            }))
        },

        async getNmumberOfCountCaseByStatus (flagId = '', startDate = '', endDate = '') {
            let countCaseByStatusList = await fgApi.caseTracking.getCountCaseByStatus(flagId, startDate, endDate)
            this.allStatus = this.mapObjectData(this.allStatus, countCaseByStatusList.data)
            this.allStatus[0].number_of_cases = this.allStatus.reduce((a, b) => a + (b.number_of_cases || 0), 0)
        },

        async getNUmberOfCoountCaseByLate (flagId = '') {
            let countDate = await fgApi.caseTracking.getCountCaseByLate(flagId)
            this.allDate = this.mapObjectData(this.allDate, [countDate.data])
        },

        async getDataFilter () {
            let priorityList = await fgApi.caseTracking.getListPriorities()
            let statusList = await fgApi.caseTracking.getListsSatus()
            let reasonList = await fgApi.caseTracking.getListsReasons()
            let flagcaseList = await fgApi.caseTracking.getListsflagCases()
            let csName = await fgApi.caseTracking.getListCsProfileAll()

            this.allCsName = csName.data
            this.allPriority = priorityList.data
            this.allFlag = flagcaseList.data
            this.allStatusTable = statusList.data
            this.allReason = await reasonList.data
        },
        changeLimitPage (val) {
            this.pagination.limit = val
            this.getlistCase()
        },
        changeCurrentPage (val) {
            this.pagination.offset = this.pagination.currentPage * this.pagination.limit - this.pagination.limit
            this.getlistCase()
        },
        second_reasons (mainReasonsRow) {
            console.log('mainReasonsRow', mainReasonsRow)
            if (mainReasonsRow === '') {
                return null
            }
            console.log('this.allReason', this.allReason)
            let reasons = this.allReason.find(e => e.description === mainReasonsRow)
            return reasons.second_reasons
        },
        filterCase () {
            var flagFilter = {
                'ทั้งหมด': '',
                'Line Case': 'Fake',
                'Flag Case': 'True'
            }
            if (this.statusFilter.code === 'ทั้งหมด') {
                this.statusFilter = ''
            }
            let flagId = flagFilter[this.flagCaseFilter] !== '' ? this.allFlag.filter(e => e.flag === flagFilter[this.flagCaseFilter])[0].flag_id.toString() : flagFilter[this.flagCaseFilter]
            let statusId = this.statusFilter !== '' ? this.statusFilter.status_id.toString() : ''
            let date = this.allDate.find(e => e.name === this.caseDateFilter)
            let startDate = typeof date !== 'undefined' ? date.start : ''
            let endDate = typeof date !== 'undefined' ? date.end : ''
            this.getlistCase(statusId, flagId, startDate, endDate)
            this.getNmumberOfCountCaseByStatus(flagId, startDate, endDate)
            this.getNUmberOfCoountCaseByLate(flagId)
        },
        async updateCase (caseTracking) {
            caseTracking.priority = this.allPriority.find(e => e.priority === caseTracking.priority.priority)
            caseTracking.flag = this.allFlag.find(e => e.flag === caseTracking.flag.flag)
            caseTracking.status = this.allStatus.find(e => e.code === caseTracking.status.code)
            let main = this.allReason.find(e => e.description === caseTracking.main_reason.description)
            caseTracking.main_reason = main
            caseTracking.second_reason = main.second_reasons.find(e => e.description === caseTracking.second_reason.description)

            let body = {
                'case_id': caseTracking.case_id,
                'order_id': caseTracking.order_id,
                'description': caseTracking.description ? caseTracking.description : '',
                'priority_id': caseTracking.priority.priority_id ? caseTracking.priority.priority_id : 0,
                'flag_id': caseTracking.flag ? caseTracking.flag.flag_id : 0,
                'status_id': caseTracking.status ? caseTracking.status.status_id : 0,
                'main_reason_id': caseTracking.main_reason ? caseTracking.main_reason.main_reason_id : 0,
                'second_reason_id': caseTracking.second_reason ? caseTracking.second_reason.second_reason_id : 0,
                'due_date': caseTracking.due_date
            }
            let respone = await fgApi.caseTracking.updateCase(body)
            if (respone) {
                this.$swal({ icon: 'success',
                    title: 'Case update success',
                    showConfirmButton: false,
                    timer: 2000 })
                this.getDataFilter()
            }
        }
    }
}
</script>

<style scoped>
.el-tabs--border-card {
    background-color: blue;
    height: 0px;
    float: center;
}
.el-tabs__nav {
    float: "center";
}
</style>
